function e(e,t){let n=Object.getOwnPropertyNames(e);const r={};for(let o=0;o<n.length;o++){const f=n[o],i=f.indexOf("$");-1!==i&&-1!==t.indexOf(f.substring(0,i+1))||-1===t.indexOf(f)&&(r[f]=e[f])}return r}export{e as exclude};
//# sourceMappingURL=exclude.js.map
